import { render, staticRenderFns } from "./BrandTutorialVideoPopup.vue?vue&type=template&id=3338a4f3&scoped=true&"
import script from "./BrandTutorialVideoPopup.vue?vue&type=script&lang=js&"
export * from "./BrandTutorialVideoPopup.vue?vue&type=script&lang=js&"
import style0 from "./BrandTutorialVideoPopup.vue?vue&type=style&index=0&id=3338a4f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338a4f3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3338a4f3')) {
      api.createRecord('3338a4f3', component.options)
    } else {
      api.reload('3338a4f3', component.options)
    }
    module.hot.accept("./BrandTutorialVideoPopup.vue?vue&type=template&id=3338a4f3&scoped=true&", function () {
      api.rerender('3338a4f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/BrandTutorialVideoPopup.vue"
export default component.exports